export const environment = {
  production: true,
  // baseApiUrl: 'https://app.db.questions.place/api/front/',
  baseApiUrl: 'https://app.db.questions.place/api/v2/front/',
  apiAuth: 'g8mM9r3K9X',
  apiPass: '33eGy6Z2Md'
};
